export class ReportsHttp {
    /**
     * Get week sheets
     * @param day
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getWeekSheets(day) {
        try {
            return await window.axios.get(`reports/${day}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get tech commission
     * @param start
     * @param end
     * @param tech
     * @param unlocked
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getTechCommission(start, end, tech, unlocked) {
        try {
            return await window.axios.get(`reports/tech/?start=${start}&end=${end}&tech=${tech}&unlocked=${unlocked}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get tech Annual
     * @param start
     * @param end
     * @param tech
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getTechAnnual(start, end, tech) {
        try {
            return await window.axios.get(`reports/annual/?start=${start}&end=${end}&tech=${tech}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update Annual Report
     * @param data
     * @return {Promise<void>}
     */
    static async updateAnnualReport(data) {
        try {
            return await window.axios.put(`reports/annual`, {data});
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
